import React, { useMemo } from 'react';
import ErrorMessage from 'shared/Messages/ErrorMessage';
import { EditableField, Props as EditableFieldProps } from 'modules/cm/fields/EditableField';
import { ContentInjectable } from 'modules/af_cm_ui_kit/components/types';
import useCaseIsReadOnly from 'helpers/hooks/useCaseIsReadOnly/useCaseIsReadOnly';
import { GetErrorsPathsFunction } from '../pages/CaseDetailsPage/hooks/useFieldError/useFieldError';

interface Props extends EditableFieldProps, Partial<ContentInjectable> {
  getErrors: GetErrorsPathsFunction;
}

const UpdatableField = ({
  onFieldChange,
  modulePrefix,
  disabled = false,
  getErrors,
  extraContent = [],
  ...props
}: Props) => {
  const isCaseReadOnly = useCaseIsReadOnly();
  const isDisabled = useMemo(() => {
    return disabled || isCaseReadOnly;
  }, [disabled, isCaseReadOnly]);
  const fieldName = props.field.name;

  const handleFieldChange = (editableField: EditableFieldProps['onFieldChange']) => {
    if (!isCaseReadOnly) {
      onFieldChange(editableField);
    }
  };

  return (
    <EditableField
      {...props}
      onFieldChange={handleFieldChange}
      modulePrefix={modulePrefix}
      readOnly={isCaseReadOnly}
      disabled={isDisabled}
      extraContent={[
        ...getErrors(fieldName).map((error: string) => ({
          position: 'bottom',
          variant: 'component',
          content: error ? <ErrorMessage message={error} /> : '',
        })),
        ...extraContent,
      ]}
    />
  );
};

export default UpdatableField;
